// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/enums/MuayThaiKickboxingNoFaceWeightClassPt.proto

/* eslint-disable */

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/**
 * 무에타이 · 킥복싱(안면타격 X) 체급 — 무에타이 · 킥복싱과 같은 체급표를 쓴다
 *
 * 안면타격 여부만 다른 종목이라 체급 · 부 · 상한이 모두 같다. 다만 종목이 다르면 대진표가 갈리므로
 * enum 은 따로 두고 값을 1:1 로 짝짓는다 (체급 숫자는 MuayThaiKickboxingWeightClassPt 와 같게 유지한다).
 *
 * 초등부 통합 21체급, 중 · 고 · 일반부 통합 19체급이며 성별을 나누지 않는다.
 * 중 · 고 · 일반부는 아톰급 · 미니플라이급이 같은 상한(-44.425kg), 라이트플라이급 · 플라이급이
 * 같은 상한(-47.627kg)이라 상한만으로는 체급이 하나로 정해지지 않는다 — 체급은 운영자가 확정한다.
 */
export enum MuayThaiKickboxingNoFaceWeightClassPayload {
  MUAY_THAI_NO_FACE_WEIGHT_CLASS_UNKNOWN = 0,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_ATOM - 초등부 아톰급 (-26kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_ATOM = 1,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_MINI_FLY - 초등부 미니플라이급 (-28kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_MINI_FLY = 2,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_FLY - 초등부 라이트플라이급 (-30kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_FLY = 3,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_FLY - 초등부 플라이급 (-32kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_FLY = 4,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FLY - 초등부 슈퍼플라이급 (-34kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FLY = 5,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_BANTAM - 초등부 밴텀급 (-36kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_BANTAM = 6,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_BANTAM - 초등부 슈퍼밴텀급 (-38kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_BANTAM = 7,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_FEATHER - 초등부 페더급 (-40kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_FEATHER = 8,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FEATHER - 초등부 슈퍼페더급 (-42kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FEATHER = 9,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT - 초등부 라이트급 (-44kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT = 10,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_LIGHT - 초등부 슈퍼라이트급 (-46kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_LIGHT = 11,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_WELTER - 초등부 주니어웰터급 (-48kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_WELTER = 12,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_WELTER - 초등부 웰터급 (-50kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_WELTER = 13,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_WELTER - 초등부 슈퍼웰터급 (-52kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_WELTER = 14,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_MIDDLE - 초등부 주니어미들급 (-54kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_MIDDLE = 15,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_MIDDLE - 초등부 미들급 (-56kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_MIDDLE = 16,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_MIDDLE - 초등부 슈퍼미들급 (-58kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_MIDDLE = 17,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_HEAVY - 초등부 라이트헤비급 (-60kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_HEAVY = 18,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_CRUISER - 초등부 크루저급 (-63.5kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_CRUISER = 19,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_HEAVY - 초등부 헤비급 (-65kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_HEAVY = 20,
  /** MUAY_THAI_NO_FACE_ELEMENTARY_UNLIMITED - 초등부 무제한급 (+71kg) */
  MUAY_THAI_NO_FACE_ELEMENTARY_UNLIMITED = 21,
  /** MUAY_THAI_NO_FACE_GENERAL_ATOM - 중 · 고 · 일반부 아톰급 (-44.425kg) */
  MUAY_THAI_NO_FACE_GENERAL_ATOM = 22,
  /** MUAY_THAI_NO_FACE_GENERAL_MINI_FLY - 중 · 고 · 일반부 미니플라이급 (-44.425kg) */
  MUAY_THAI_NO_FACE_GENERAL_MINI_FLY = 23,
  /** MUAY_THAI_NO_FACE_GENERAL_LIGHT_FLY - 중 · 고 · 일반부 라이트플라이급 (-47.627kg) */
  MUAY_THAI_NO_FACE_GENERAL_LIGHT_FLY = 24,
  /** MUAY_THAI_NO_FACE_GENERAL_FLY - 중 · 고 · 일반부 플라이급 (-47.627kg) */
  MUAY_THAI_NO_FACE_GENERAL_FLY = 25,
  /** MUAY_THAI_NO_FACE_GENERAL_SUPER_FLY - 중 · 고 · 일반부 슈퍼플라이급 (-50.802kg) */
  MUAY_THAI_NO_FACE_GENERAL_SUPER_FLY = 26,
  /** MUAY_THAI_NO_FACE_GENERAL_BANTAM - 중 · 고 · 일반부 밴텀급 (-52.163kg) */
  MUAY_THAI_NO_FACE_GENERAL_BANTAM = 27,
  /** MUAY_THAI_NO_FACE_GENERAL_SUPER_BANTAM - 중 · 고 · 일반부 슈퍼밴텀급 (-53.524kg) */
  MUAY_THAI_NO_FACE_GENERAL_SUPER_BANTAM = 28,
  /** MUAY_THAI_NO_FACE_GENERAL_FEATHER - 중 · 고 · 일반부 페더급 (-55.338kg) */
  MUAY_THAI_NO_FACE_GENERAL_FEATHER = 29,
  /** MUAY_THAI_NO_FACE_GENERAL_SUPER_FEATHER - 중 · 고 · 일반부 슈퍼페더급 (-57.153kg) */
  MUAY_THAI_NO_FACE_GENERAL_SUPER_FEATHER = 30,
  /** MUAY_THAI_NO_FACE_GENERAL_LIGHT - 중 · 고 · 일반부 라이트급 (-58.967kg) */
  MUAY_THAI_NO_FACE_GENERAL_LIGHT = 31,
  /** MUAY_THAI_NO_FACE_GENERAL_SUPER_LIGHT - 중 · 고 · 일반부 슈퍼라이트급 (-61.235kg) */
  MUAY_THAI_NO_FACE_GENERAL_SUPER_LIGHT = 32,
  /** MUAY_THAI_NO_FACE_GENERAL_WELTER - 중 · 고 · 일반부 웰터급 (-63.503kg) */
  MUAY_THAI_NO_FACE_GENERAL_WELTER = 33,
  /** MUAY_THAI_NO_FACE_GENERAL_SUPER_WELTER - 중 · 고 · 일반부 슈퍼웰터급 (-66.678kg) */
  MUAY_THAI_NO_FACE_GENERAL_SUPER_WELTER = 34,
  /** MUAY_THAI_NO_FACE_GENERAL_MIDDLE - 중 · 고 · 일반부 미들급 (-69.853kg) */
  MUAY_THAI_NO_FACE_GENERAL_MIDDLE = 35,
  /** MUAY_THAI_NO_FACE_GENERAL_SUPER_MIDDLE - 중 · 고 · 일반부 슈퍼미들급 (-72.575kg) */
  MUAY_THAI_NO_FACE_GENERAL_SUPER_MIDDLE = 36,
  /** MUAY_THAI_NO_FACE_GENERAL_LIGHT_HEAVY - 중 · 고 · 일반부 라이트헤비급 (-76.204kg) */
  MUAY_THAI_NO_FACE_GENERAL_LIGHT_HEAVY = 37,
  /** MUAY_THAI_NO_FACE_GENERAL_CRUISER - 중 · 고 · 일반부 크루저급 (-79.379kg) */
  MUAY_THAI_NO_FACE_GENERAL_CRUISER = 38,
  /** MUAY_THAI_NO_FACE_GENERAL_HEAVY - 중 · 고 · 일반부 헤비급 (-83.914kg) */
  MUAY_THAI_NO_FACE_GENERAL_HEAVY = 39,
  /** MUAY_THAI_NO_FACE_GENERAL_UNLIMITED - 중 · 고 · 일반부 무제한급 (+87.996kg) */
  MUAY_THAI_NO_FACE_GENERAL_UNLIMITED = 40,
  UNRECOGNIZED = -1,
}

export function muayThaiKickboxingNoFaceWeightClassPayloadFromJSON(
  object: any,
): MuayThaiKickboxingNoFaceWeightClassPayload {
  switch (object) {
    case 0:
    case "MUAY_THAI_NO_FACE_WEIGHT_CLASS_UNKNOWN":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_WEIGHT_CLASS_UNKNOWN;
    case 1:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_ATOM":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_ATOM;
    case 2:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_MINI_FLY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_MINI_FLY;
    case 3:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_FLY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_FLY;
    case 4:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_FLY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_FLY;
    case 5:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FLY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FLY;
    case 6:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_BANTAM":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_BANTAM;
    case 7:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_BANTAM":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_BANTAM;
    case 8:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_FEATHER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_FEATHER;
    case 9:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FEATHER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FEATHER;
    case 10:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT;
    case 11:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_LIGHT":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_LIGHT;
    case 12:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_WELTER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_WELTER;
    case 13:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_WELTER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_WELTER;
    case 14:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_WELTER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_WELTER;
    case 15:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_MIDDLE":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_MIDDLE;
    case 16:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_MIDDLE":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_MIDDLE;
    case 17:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_MIDDLE":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_MIDDLE;
    case 18:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_HEAVY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_HEAVY;
    case 19:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_CRUISER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_CRUISER;
    case 20:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_HEAVY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_HEAVY;
    case 21:
    case "MUAY_THAI_NO_FACE_ELEMENTARY_UNLIMITED":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_UNLIMITED;
    case 22:
    case "MUAY_THAI_NO_FACE_GENERAL_ATOM":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_ATOM;
    case 23:
    case "MUAY_THAI_NO_FACE_GENERAL_MINI_FLY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_MINI_FLY;
    case 24:
    case "MUAY_THAI_NO_FACE_GENERAL_LIGHT_FLY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_LIGHT_FLY;
    case 25:
    case "MUAY_THAI_NO_FACE_GENERAL_FLY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_FLY;
    case 26:
    case "MUAY_THAI_NO_FACE_GENERAL_SUPER_FLY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_FLY;
    case 27:
    case "MUAY_THAI_NO_FACE_GENERAL_BANTAM":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_BANTAM;
    case 28:
    case "MUAY_THAI_NO_FACE_GENERAL_SUPER_BANTAM":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_BANTAM;
    case 29:
    case "MUAY_THAI_NO_FACE_GENERAL_FEATHER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_FEATHER;
    case 30:
    case "MUAY_THAI_NO_FACE_GENERAL_SUPER_FEATHER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_FEATHER;
    case 31:
    case "MUAY_THAI_NO_FACE_GENERAL_LIGHT":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_LIGHT;
    case 32:
    case "MUAY_THAI_NO_FACE_GENERAL_SUPER_LIGHT":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_LIGHT;
    case 33:
    case "MUAY_THAI_NO_FACE_GENERAL_WELTER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_WELTER;
    case 34:
    case "MUAY_THAI_NO_FACE_GENERAL_SUPER_WELTER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_WELTER;
    case 35:
    case "MUAY_THAI_NO_FACE_GENERAL_MIDDLE":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_MIDDLE;
    case 36:
    case "MUAY_THAI_NO_FACE_GENERAL_SUPER_MIDDLE":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_MIDDLE;
    case 37:
    case "MUAY_THAI_NO_FACE_GENERAL_LIGHT_HEAVY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_LIGHT_HEAVY;
    case 38:
    case "MUAY_THAI_NO_FACE_GENERAL_CRUISER":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_CRUISER;
    case 39:
    case "MUAY_THAI_NO_FACE_GENERAL_HEAVY":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_HEAVY;
    case 40:
    case "MUAY_THAI_NO_FACE_GENERAL_UNLIMITED":
      return MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_UNLIMITED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MuayThaiKickboxingNoFaceWeightClassPayload.UNRECOGNIZED;
  }
}

export function muayThaiKickboxingNoFaceWeightClassPayloadToJSON(
  object: MuayThaiKickboxingNoFaceWeightClassPayload,
): string {
  switch (object) {
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_WEIGHT_CLASS_UNKNOWN:
      return "MUAY_THAI_NO_FACE_WEIGHT_CLASS_UNKNOWN";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_ATOM:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_ATOM";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_MINI_FLY:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_MINI_FLY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_FLY:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_FLY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_FLY:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_FLY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FLY:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FLY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_BANTAM:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_BANTAM";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_BANTAM:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_BANTAM";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_FEATHER:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_FEATHER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FEATHER:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_FEATHER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_LIGHT:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_LIGHT";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_WELTER:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_WELTER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_WELTER:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_WELTER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_WELTER:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_WELTER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_MIDDLE:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_JUNIOR_MIDDLE";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_MIDDLE:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_MIDDLE";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_MIDDLE:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_SUPER_MIDDLE";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_HEAVY:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_LIGHT_HEAVY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_CRUISER:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_CRUISER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_HEAVY:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_HEAVY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_ELEMENTARY_UNLIMITED:
      return "MUAY_THAI_NO_FACE_ELEMENTARY_UNLIMITED";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_ATOM:
      return "MUAY_THAI_NO_FACE_GENERAL_ATOM";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_MINI_FLY:
      return "MUAY_THAI_NO_FACE_GENERAL_MINI_FLY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_LIGHT_FLY:
      return "MUAY_THAI_NO_FACE_GENERAL_LIGHT_FLY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_FLY:
      return "MUAY_THAI_NO_FACE_GENERAL_FLY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_FLY:
      return "MUAY_THAI_NO_FACE_GENERAL_SUPER_FLY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_BANTAM:
      return "MUAY_THAI_NO_FACE_GENERAL_BANTAM";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_BANTAM:
      return "MUAY_THAI_NO_FACE_GENERAL_SUPER_BANTAM";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_FEATHER:
      return "MUAY_THAI_NO_FACE_GENERAL_FEATHER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_FEATHER:
      return "MUAY_THAI_NO_FACE_GENERAL_SUPER_FEATHER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_LIGHT:
      return "MUAY_THAI_NO_FACE_GENERAL_LIGHT";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_LIGHT:
      return "MUAY_THAI_NO_FACE_GENERAL_SUPER_LIGHT";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_WELTER:
      return "MUAY_THAI_NO_FACE_GENERAL_WELTER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_WELTER:
      return "MUAY_THAI_NO_FACE_GENERAL_SUPER_WELTER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_MIDDLE:
      return "MUAY_THAI_NO_FACE_GENERAL_MIDDLE";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_SUPER_MIDDLE:
      return "MUAY_THAI_NO_FACE_GENERAL_SUPER_MIDDLE";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_LIGHT_HEAVY:
      return "MUAY_THAI_NO_FACE_GENERAL_LIGHT_HEAVY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_CRUISER:
      return "MUAY_THAI_NO_FACE_GENERAL_CRUISER";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_HEAVY:
      return "MUAY_THAI_NO_FACE_GENERAL_HEAVY";
    case MuayThaiKickboxingNoFaceWeightClassPayload.MUAY_THAI_NO_FACE_GENERAL_UNLIMITED:
      return "MUAY_THAI_NO_FACE_GENERAL_UNLIMITED";
    case MuayThaiKickboxingNoFaceWeightClassPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
